import Slide from "../../../../../../components/Slide";
import { Box, Grid, makeStyles } from "@material-ui/core";
import { theme } from "../../../../../../theme";

import ZitatImage from "../../../../../../assets/_Chapters/Karriere/Zitate/ausbildung-und-studium-1.webp";

const useStyles = makeStyles((theme) => ({
  fontRegular: {
    marginTop: "5px",
    fontWeight: 400,
  },
  heightCorrection: {
    display: "flex",
    justifyContent: "center",
    height: "calc(100dvh - 90px * 2)",
  },
}));
export default function Zitat1() {
  const classes = useStyles();
  return (
    <Slide background={{ width: "100dvw", color: theme.palette.primary.main }}>
      <Grid container alignItems="center" spacing={5}>
        <Grid item xs={12}>
          <Box className={classes.heightCorrection}>
            <svg
              style={{ width: "100%", height: "100%" }}
              width="1932"
              height="990"
              viewBox="0 0 1932 990"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <g clip-path="url(#clip0_888_383)">
                <text
                  fill="white"
                  xmlSpace="preserve"
                  style="white-space: pre"
                  font-family="Interstate"
                  font-size="30"
                  letter-spacing="0em"
                >
                  <tspan x="1231" y="946.8">
                    Louis, Ausbildung zum Kaufmann f&#xfc;r
                  </tspan>
                  <tspan x="1231" y="982.8">
                    Gro&#xdf;- und Au&#xdf;enhandelsmanagement
                  </tspan>
                </text>
                <mask
                  id="mask0_888_383"
                  style="mask-type:alpha"
                  maskUnits="userSpaceOnUse"
                  x="1231"
                  y="0"
                  width="701"
                  height="901"
                >
                  <rect x="1231" width="701" height="901" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_888_383)">
                  <rect
                    x="1231"
                    y="-101"
                    width="701"
                    height="1051"
                    fill="url(#pattern0_888_383)"
                  />
                </g>
                <text
                  fill="white"
                  xmlSpace="preserve"
                  style="white-space: pre"
                  font-family="Interstate"
                  font-size="120"
                  font-weight="bold"
                  letter-spacing="0em"
                >
                  <tspan x="0" y="361.2">
                    &#x201e;Durch die Du-Kultur&#xa0;&#xa0;{" "}
                  </tspan>
                  <tspan x="0" y="505.2">
                    begegnet man mir stets{" "}
                  </tspan>
                  <tspan x="0" y="649.2">
                    respektvoll und auf{" "}
                  </tspan>
                  <tspan x="0" y="793.2">
                    Augenh&#xf6;he.&#x201c;
                  </tspan>
                </text>
              </g>
              <defs>
                <pattern
                  id="pattern0_888_383"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    xlinkHref="#image0_888_383"
                    transform="scale(0.000366166 0.000244227)"
                  />
                </pattern>
                <clipPath id="clip0_888_383">
                  <rect width="1932" height="990" fill="white" />
                </clipPath>
                <image
                  id="image0_888_383"
                  width="2731"
                  height="4096"
                  xlinkHref={ZitatImage}
                />
              </defs>
            </svg>
          </Box>
        </Grid>
      </Grid>
    </Slide>
  );
}
